
import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="bg-white shadow-lg sticky top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
            <div className="text-2xl font-bold" style={{ fontFamily: 'Georgia, serif' }}>
              <span className="text-red-600">PGVH</span>
              <span className="text-black">armony</span>
              <span className="text-gray-600 text-sm ml-1">F.Z.E.</span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('home')}
              className="text-gray-700 hover:text-red-600 font-medium transition-colors cursor-pointer"
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('products')}
              className="text-gray-700 hover:text-red-600 font-medium transition-colors cursor-pointer"
            >
              Products
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-gray-700 hover:text-red-600 font-medium transition-colors cursor-pointer"
            >
              Contact Us
            </button>
            <button
              onClick={() => scrollToSection('suppliers')}
              className="bg-red-600 text-white px-6 py-2 rounded-lg hover:bg-red-700 transition-colors font-medium whitespace-nowrap cursor-pointer"
            >
              Suppliers
            </button>
          </nav>

          {/* UAE Flag - Top Right Corner */}
          <div className="hidden md:block absolute top-4 right-4">
            <div className="w-12 h-8 border border-gray-300 rounded shadow-md overflow-hidden relative">
              <div className="absolute left-0 top-0 w-4 h-8 bg-red-500"></div>
              <div className="h-1/3 bg-green-500"></div>
              <div className="h-1/3 bg-white"></div>
              <div className="h-1/3 bg-black"></div>
            </div>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden text-gray-700 hover:text-red-600 cursor-pointer"
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            {/* UAE Flag - Mobile */}
            <div className="flex justify-end mb-4">
              <div className="w-12 h-8 border border-gray-300 rounded shadow-md overflow-hidden relative">
                <div className="absolute left-0 top-0 w-4 h-8 bg-red-500"></div>
                <div className="h-1/3 bg-green-500"></div>
                <div className="h-1/3 bg-white"></div>
                <div className="h-1/3 bg-black"></div>
              </div>
            </div>
            
            <div className="flex flex-col space-y-4">
              <button
                onClick={() => scrollToSection('home')}
                className="text-gray-700 hover:text-red-600 font-medium transition-colors text-left cursor-pointer"
              >
                Home
              </button>
              <button
                onClick={() => scrollToSection('products')}
                className="text-gray-700 hover:text-red-600 font-medium transition-colors text-left cursor-pointer"
              >
                Products
              </button>
              <button
                onClick={() => scrollToSection('contact')}
                className="text-gray-700 hover:text-red-600 font-medium transition-colors text-left cursor-pointer"
              >
                Contact Us
              </button>
              <button
                onClick={() => scrollToSection('suppliers')}
                className="bg-red-600 text-white px-6 py-2 rounded-lg hover:bg-red-700 transition-colors font-medium text-center whitespace-nowrap cursor-pointer"
              >
                Suppliers
              </button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
